<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <dropdown :class="['mr-1']" :items="yPositions" v-model="yPos" width="128px" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" /><!--
          --><dropdown :class="['mx-1']" :items="xPositions" v-model="xPos" width="128px" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="3" md6 v-for="(badge, index) in badges" :key="index" >
        <card align="center">
          <card-text>
            <badge :class="['m-2']" :text="badge.text" :bg-color="$root.colors.primary" :y-pos="yPos[0]" :x-pos="xPos[0]" :bg-color-lightness="$root.colors.bgColorLightness">
              <icon :name="badge.icon" size="2.5" />
            </badge>
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageBadge',
  mixins: [
    methods
  ],
  data () {
    return {
      yPos: ['top'],
      xPos: ['right'],
      yPositions: ['top', 'bottom'].map(position => {
        return {
          text: this.firstLetterCapital(position),
          value: position
        }
      }),
      xPositions: ['left', 'right'].map(position => {
        return {
          text: this.firstLetterCapital(position),
          value: position
        }
      }),
      badges: []
    }
  },
  mounted () {
    this.getExternalData('badge.json', 'badges')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/badge.vue